import React from 'react'
import { Provider } from 'react-redux'
import { Switch, Route } from 'react-router'
import { ConnectedRouter } from 'react-router-redux'

import App from './App'

import { requireAuthentication } from '../components/AuthenticatedComponent'
import LoginCustomerView from '../views/LoginCustomerView'
import LoginPromoterView from '../views/LoginPromoterView'
import PasswordRecoveryClientView from '../views/PasswordRecoveryClientView'
import PasswordAssignClientView from '../views/PasswordAssignClientView'

// AI
import Receptionist from '../ai/Receptionist'

import 'bootstrap/dist/css/bootstrap.css';
import '../style.css'

class Root extends React.Component {
  render() {
    return (
      <Provider store={this.props.store}>
        <ConnectedRouter history={this.props.history}>
          <Switch>
            <Route exact path="/login" component={LoginCustomerView} />
            <Route exact path="/promoter" component={LoginPromoterView} />
            <Route exact path="/passwordrecoveryclient" component={PasswordRecoveryClientView} />
            <Route exact path="/passwordassignclient" component={PasswordAssignClientView} />
            <Route exact path="/receptionist" component={Receptionist} />
            <Route path="/" component={requireAuthentication(App)} />
          </Switch>
        </ConnectedRouter>
      </Provider>

    )
  }
}

export default Root
